import {ReactNode, useContext} from "react";
import {createContext} from "react";
import {CarStore} from "../store/car-store";

type Props = {
  children: ReactNode;
  store: CarStore;
};

const Context = createContext<CarStore | undefined>(undefined);
export const useStore = () => {
  const carStore = useContext(Context);
  if (!carStore) {
    throw new Error(
      "useStore must be used inside WidgetContextProvider"
    );
  }
  return {
    carStore
  };
};

export const WidgetContextProvider = (props: Props) => {

  return (
      <Context.Provider value={props.store}>
        {props.children}
      </Context.Provider>
  );
};
